import {
    ApiClient,
    CurrentStageAndConfig,
    getCurrentStageAndConfig,
  } from "@amzn/rangoli-seller-desktop-async-call-wrapper/src/index";
  
  const { config: currentStage }: CurrentStageAndConfig =
    getCurrentStageAndConfig();
  
  const smartbizConfig = {
    url: currentStage.smartbizUrl,
  };
  
  const smartbizConfigClient = new ApiClient(smartbizConfig);
  export const smartbizUrl = smartbizConfigClient.api();